module.exports = __webpack_public_path__ + "img/117.d458e952.jpg";